import { Link } from "react-router-dom";

interface StickyCTAProps {
  visible: boolean;
}

export default function StickyCTA({ visible }: StickyCTAProps) {
  const shown = visible
    ? "opacity-100 visible"
    : "opacity-0 invisible pointer-events-none";

  return (
    <>
      {/* Desktop: floating amber pill */}
      <div
        aria-hidden={!visible}
        className={`fixed z-50 hidden md:block transition-opacity duration-200 motion-reduce:transition-none ${shown}`}
        style={{ bottom: "clamp(1.25rem, 4vh, 1.5rem)", right: "clamp(0.75rem, 2vw, 1.5rem)" }}
      >
        <Link
          to="/coach"
          tabIndex={visible ? undefined : -1}
          className="btn-primary shadow-[0_10px_30px_-8px_hsl(var(--marigold)/0.55)]"
        >
          Start a Session
        </Link>
      </div>

      {/* Mobile: full-width sticky bar, sits above BottomTabBar */}
      <div
        aria-hidden={!visible}
        className={`fixed left-0 right-0 z-40 md:hidden px-4 transition-opacity duration-200 motion-reduce:transition-none ${shown}`}
        style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 4.5rem)" }}
      >
        <Link
          to="/onboarding"
          tabIndex={visible ? undefined : -1}
          className="btn-primary w-full text-center block"
          style={{ borderRadius: "var(--radius-pill)" }}
        >
          Start a Session
        </Link>
        <p
          className="mt-1.5 text-center text-manuscript/60"
          style={{ fontSize: 10, letterSpacing: "0.04em" }}
        >
          3 free sessions a week. No card.
        </p>
      </div>
    </>
  );
}
